import {
  Dialog,
  DialogContent,
  Grid,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Button,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import React, { useState } from "react";
import useStyles from "../../themes/style.js";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { useNotification } from "../../hooks/useNotification.js";

const EmployeeLeaveLimit = ({ userId, isModalOpen, handleModalClose }) => {
  const classes = useStyles();
  const [values, setValues] = useState({
    showPassword: false,
  });
  const [loader, setLoader] = useState(false);

  const token = localStorage.getItem("token");
  const decode = jwtDecode(token);

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleNotificationCall = useNotification();

  const validationSchema = Yup.object().shape({
    casual: Yup.number().required("No. of Casual Leave is required"),
    sick: Yup.number().required("No. of Sick Leave is required"),
    personal: Yup.number().required("No. of Privilege leave is required"),
    permission: Yup.number().required("No. of Permission is required"),
  });

  const {
    register,
    control,
    reset,
    handleSubmit,
    setValue,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const handleAddEmployee = async (values) => {
    setLoader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}leave/addLeavebalance`,
        { ...values, userId: userId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        handleModalClose();
      } else {
        handleNotificationCall("error", response.data.message);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  return (
    <div>
      <Dialog
        aria-labelledby="dialog-title"
        onClose={handleModalClose}
        open={isModalOpen}
        fullWidth={true}
        maxWidth="xs"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
      >
        <h3 style={{ padding: "12px 12px", margin: 0 }}>
          Employee Leave Details
        </h3>
        <DialogContent>
          <Grid container direction="row" spacing={2}>
            <Grid>
              <form onSubmit={handleSubmit(handleAddEmployee)}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                  }}
                >
                  <Grid container direction="row" spacing={2}>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <InputLabel shrink htmlFor="casual">
                        Casual Leave
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          placeholder="Enter Marital Staus"
                          name="casual"
                          type="number"
                          {...register("casual")}
                          error={errors.casual ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {errors.casual?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <InputLabel shrink htmlFor="sick">
                        Sick Leave
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          type="number"
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          placeholder="Enter Sick Leave Count"
                          name="sick"
                          {...register("sick")}
                          error={errors.sick ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {errors.sick?.message}
                        </Typography>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <InputLabel shrink htmlFor="personal">
                        Privilege leave
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          placeholder="Enter Privilege leave Count"
                          name="personal"
                          type="number"
                          {...register("personal")}
                          error={errors.personal ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {errors.personal?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <InputLabel shrink htmlFor="permission">
                        Permission
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          placeholder="Enter No. of Permission  "
                          name="permission"
                          type="number"
                          {...register("permission")}
                          error={errors.permission ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {errors.permission?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                  </Grid>
                </div>
                <Grid
                  container
                  direction="row"
                  spacing={2}
                  style={{
                    padding: "24px 10px",
                    display: "flex",
                    gap: "20px",
                  }}
                >
                  <Button
                    variant="contained"
                    size="small"
                    color="secondary"
                    onClick={handleModalClose}
                    style={{ flex: 1 }}
                  >
                    Close
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    disabled={isSubmitting}
                    style={{ flex: 1 }}
                    type="submit"
                  >
                    Save
                  </Button>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default EmployeeLeaveLimit;
